import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';

import { showError } from '../../utils/MessagePopup';
import Popups from '../../components/Popup';
import { getEmailTemplatePreview } from '../../actions/mailingInfo';
import { usePopupContext } from '../../contexts/PopupContext';

const EmailTemplatePreviewPopupContainer = ({
  popup,
  queryResults,
  isLoadingTemplatePreview,
  templatePreview,
  getEmailTemplatePreview,
}) => {
  const { openPopup, closePopup } = usePopupContext();
  const [index, setIndex] = useState(0);
  const templateId = popup.getIn(['props', 'templateId']);

  const afterError = responseBody => {
    if (responseBody) {
      showError(openPopup, [responseBody.message], closePopup());
    }
  };

  useEffect(() => {
    getEmailTemplatePreview({
      templateId,
      targetId: queryResults.get(index).targetId,
      afterError: ({ responseBody }) => afterError(responseBody),
    });
  }, [queryResults, index]);

  const handlePrevClick = () => {
    if (index !== 0) {
      setIndex(index - 1);
    } else {
      setIndex(queryResults.size - 1);
    }
  };

  const handleNextClick = () => {
    if (index < queryResults.size - 1) {
      setIndex(index + 1);
    } else {
      setIndex(0);
    }
  };

  const handleEditClick = () => {
    window.open(`/email-templates-management?id=${templateId}`, '_blank');
  };

  return (
    <Popups.EmailTemplatePreviewPopup
      onEdit={handleEditClick}
      onNext={handleNextClick}
      onPrev={handlePrevClick}
      popupLoading={isLoadingTemplatePreview}
      templatePreview={templatePreview}
    />
  );
};

const mapStateToProps = state => ({
  templatePreview: state.mailingInfo.get('templatePreview'),
  queryResults: state.mailingInfo.get('queryResults'),
  isLoadingTemplatePreview: state.mailingInfo.get('isLoadingTemplatePreview'),
});

const mapActionToProps = {
  getEmailTemplatePreview,
};

export { EmailTemplatePreviewPopupContainer };
export default connect(mapStateToProps, mapActionToProps)(memo(EmailTemplatePreviewPopupContainer));
